export default __webpack_public_path__ + "static/media/example_top.3192e78e.png";